/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Recurrence frequency
 */
export type RecurrenceRequestFreq = (typeof RecurrenceRequestFreq)[keyof typeof RecurrenceRequestFreq];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecurrenceRequestFreq = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const;
